import { boot } from 'quasar/wrappers'

const Constants = {
   // Serveur
   APP_VERSION: "1.0",
   SERVER_URL: "http://keszeg.belvarosiepito.hu",
   SERVER_MEDIA: "http://keszeg.belvarosiepito.hu/media",
   //SERVER_URL: "http://192.168.0.3",
   //SERVER_MEDIA: "http://192.168.0.3/storage/app/media"

   // IHM
   button_color: "red"
};
export default boot(({ app }) => {
  app.config.globalProperties.$Constants = Constants
})

export { Constants }